import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Alert from 'li-components/lib/Alert'
import Spinner from 'li-components/lib/Spinner'
import { injectGlobalStyles } from '../styles'

import { _auth, actions, alert, updateUi } from '../lib'
import { isEmpty, getPathname, getEffectiveUser, windowReload } from '../util'
import { HelpCenter } from '../help'
import Header from './Header'

export class Application extends Component {
  static propTypes = {
    onFullyAuthenticated: PropTypes.func,
    onSearch: PropTypes.func,
    appId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    customNav: PropTypes.func,
    customSearch: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    alertConfig: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    appShellUi: PropTypes.object.isRequired,
    initialAppShellUiState: PropTypes.object,
    isActiveAppLink: PropTypes.func,
    rootUrl: PropTypes.string,
    useRelativeRegistrationLink: PropTypes.bool,
    useRelativePasswordResetLink: PropTypes.bool,
    helpLabel: PropTypes.string,
    hasChat: PropTypes.bool,
    canRenderApp: PropTypes.func,
    onChangeProfile: PropTypes.func,
    shouldInjectGlobalStyles: PropTypes.bool,
  }

  static defaultProps = {
    initialAppShellUiState: {},
    useRelativeRegistrationLink: false,
    useRelativePasswordResetLink: false,
    helpLabel: '',
    hasChat: false,
    canRenderApp: () => true,
    shouldInjectGlobalStyles: true,
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  static childContextTypes = {
    onFullyAuthenticated: PropTypes.func.isRequired,
    onSearch: PropTypes.func,
    appId: PropTypes.string.isRequired,
    customNav: PropTypes.func,
    customSearch: PropTypes.func,
    isActiveAppLink: PropTypes.func,
    rootUrl: PropTypes.string,
    useRelativeRegistrationLink: PropTypes.bool,
    useRelativePasswordResetLink: PropTypes.bool,
    helpLabel: PropTypes.string,
    getEffectiveUser: PropTypes.func.isRequired,
    onChangeProfile: PropTypes.func.isRequired,
    hasChat: PropTypes.bool.isRequired,
    shouldInjectGlobalStyles: PropTypes.bool,
  }

  static publicPaths = /second-factor|login|verify-(email|token)|password|register/i

  static autoLogoutInterval = null

  getChildContext() {
    return {
      onFullyAuthenticated: this.onFullyAuthenticated,
      onSearch: this.props.onSearch,
      appId: this.props.appId,
      customNav: this.props.customNav,
      customSearch: this.props.customSearch,
      isActiveAppLink: this.props.isActiveAppLink,
      rootUrl: this.props.initialAppShellUiState.rootUrl,
      useRelativeRegistrationLink: this.props.useRelativeRegistrationLink,
      useRelativePasswordResetLink: this.props.useRelativePasswordResetLink,
      helpLabel: this.props.helpLabel,
      getEffectiveUser,
      onChangeProfile: this.onChangeProfile,
      hasChat: this.props.hasChat,
      shouldInjectGlobalStyles: this.props.shouldInjectGlobalStyles,
    }
  }

  componentWillMount() {
    const {
      dispatch,
      initialAppShellUiState,
      appShellUi,
      shouldInjectGlobalStyles,
    } = this.props
    dispatch(updateUi({ ...appShellUi, ...initialAppShellUiState }))

    if (shouldInjectGlobalStyles) {
      injectGlobalStyles()
    }
  }

  async componentDidMount() {
    await this.props.dispatch(actions.authRun())

    if (this.props.auth.user.authenticated && this.props.auth.user.verified) {
      this.onFullyAuthenticated(this.context.router)
    }
  }

  onFullyAuthenticated = (...args) =>
    (this.props.onFullyAuthenticated || this.defaultOnFullyAuthenticated)(
      ...args
    )

  defaultOnFullyAuthenticated = (router, redirectPath) => {
    if (redirectPath && redirectPath !== '/') {
      router.push(redirectPath)
    } else if (!getPathname().includes(this.props.appId)) {
      router.push(`/${this.props.appId}`)
    }
  }

  closeHelpCenter = () => {
    this.props.dispatch(updateUi({ showHelpCenter: false }))
  }

  onChangeProfile = async organizationId => {
    await this.props.dispatch(actions.authSwitchProfile(organizationId))

    if (this.props.onChangeProfile) {
      this.props.onChangeProfile()
    } else {
      windowReload()
    }
  }

  renderChildren(children) {
    const { canRenderApp, auth } = this.props
    const userExistsOnStore = !isEmpty(auth.user)
    const isPublicPath = Application.publicPaths.test(getPathname())

    if (isPublicPath || (userExistsOnStore && canRenderApp())) {
      if (!isPublicPath) {
        this.runAutoLogoutInterval()
        this.runAutoRenewInterval()
      }

      return children
    }

    return <Spinner isShowing />
  }

  runAutoLogoutInterval() {
    Application.autoLogoutInterval =
      Application.autoLogoutInterval || setInterval(this.logoutIfNoToken, 100)
  }

  logoutIfNoToken = async () => {
    if (_auth.getUser() && !_auth.getToken()) {
      const { pathname, search } = global.location
      clearInterval(Application.autoLogoutInterval)
      await this.props.dispatch(actions.authLogout())
      this.context.router.push(`/login?redirectPath=${pathname + search}`)
    }
  }

  runAutoRenewInterval() {
    Application.autoRenewInterval =
      Application.autoRenewInterval || setInterval(this.safeRenewToken, 60000)
  }

  safeRenewToken = () => {
    this.props.dispatch(actions.authSafeRenewToken())
  }

  render() {
    const { children, alertConfig, dispatch, appShellUi } = this.props

    return (
      <div className="AppShell">
        <Alert
          show={alertConfig.show}
          type={alertConfig.kind}
          title={alertConfig.title}
          selfDestruct={alertConfig.selfDestruct}
          largeAlert={alertConfig.largeAlert}
          onClose={() => dispatch(alert({ show: false }))}
          className="AppShellAlert"
        >
          {alertConfig.message}
        </Alert>

        <Header />

        <HelpCenter
          show={appShellUi.showHelpCenter}
          onClose={this.closeHelpCenter}
        />

        {this.renderChildren(children)}
      </div>
    )
  }
}

export default connect(
  // eslint-disable-next-line no-shadow
  ({ alert, auth, appShellUi, featureFlags }) => ({
    alertConfig: alert,
    auth,
    appShellUi,
    featureFlags,
  }),
  dispatch => ({ dispatch }),
  null,
  { pure: false }
)(Application)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Application.js